
import React, { useEffect } from "react";
import HeaderUpdated from "@/components/HeaderUpdated";
import Hero from "@/components/Hero";
import Categories from "@/components/Categories";
import FeaturedProducts from "@/components/FeaturedProducts";
import PromoBanner from "@/components/PromoBanner";
import AllProducts from "@/components/AllProducts";
import AppPromo from "@/components/AppPromo";
import Brands from "@/components/Brands";
import Footer from "@/components/Footer";
import { TooltipProvider } from "@/components/ui/tooltip";

const Index = () => {
  useEffect(() => {
    // Scroll to top when the page loads
    window.scrollTo(0, 0);
    
    // Add smooth reveal animations based on scrolling
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fadeIn");
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll(".animate-on-scroll");
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <TooltipProvider>
      <div className="min-h-screen bg-brand-darker text-white">
        <HeaderUpdated />
        <main className="overflow-x-hidden">
          <Hero />
          <Categories />
          <FeaturedProducts />
          <PromoBanner />
          <AllProducts />
          <AppPromo />
          <Brands />
        </main>
        <Footer />
      </div>
    </TooltipProvider>
  );
};

export default Index;
